import listSaga from './listSaga'
import createSaga from './createSaga'
import createByAdminSaga from './createByAdminSaga'
import editSaga from './editSaga'
import deleteSaga from './deleteSaga'

const tagsSagas = [listSaga(), createSaga(), createByAdminSaga(), editSaga(), deleteSaga()]

export default tagsSagas
